
export default {
  props: {
    isActive: {
      type: Boolean,
      required: false,
    },
  },
}
